import Vue from "vue";
import errors from "@/data/errors";
import store from "@/store";

export const objToFormData = obj => {
  const formData = new FormData();
  Object.entries(obj).forEach(([key, value]) => {
    formData.append(key, value);
  });
  return formData;
};

export const handleError = res => {
  let text = "There was an error with the request.";
  if (res.error && res.error.code && errors[res.error.code]) {
    text = errors[res.error.code];
  } else if (res.error && res.error.message) {
    text = res.error.message;
  }
  Vue.notify({
    type: "error",
    title: "Error:",
    text,
    duration: 5000
  });
};

function fetchMethod(method = "GET") {
  return (url, value, config = {}) => {
    const defaults = {
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    };

    let token = store.state.user.token.value;
    if (!token && document.cookie.includes("nanotoken=")) {
      token = document.cookie.split("nanotoken=")[1].split(";")[0];
    }
    if (url.includes("/admin/") && store.state.adminSession) {
      token = store.state.adminSession.token.value;
    }
    if (token) {
      defaults.headers["Authorization"] = `Bearer ${token}`;
    }

    config = Object.assign(defaults, { method }, config);

    if (value) {
      if (method === "GET") {
        url += "?" + new URLSearchParams(value);
      } else {
        if (typeof value === "object") {
          if (value.source === undefined) {
            // show only domain and page (no protocol or query params)
            const { host, pathname } = window.location;
            value.source = `web:${host + pathname}`;
          }
          value = JSON.stringify(value);
        }
        config.body = value;
      }
    }

    const doRequest = (url, config) => {
      return fetch(url, config)
        .then(async res => {
          const data = await res.json();
          if (!res.ok) {
            throw data;
          }
          return data;
        })
        .catch(async res => {
          if (res.error && res.error.code.startsWith("2FA_")) {
            const code = await store.dispatch("request2FA").catch(() => {});
            if (code) {
              config.headers["X-Nanome-2FA"] = code;
              const result = await doRequest(url, config);
              store.commit("SET_2FA_REQUEST", null);
              return result;
            } else {
              store.commit("SET_2FA_REQUEST", null);
            }
          }
          handleError(res);
          return res;
        });
    };

    return doRequest(url, config);
  };
}

export const get = fetchMethod();

export const post = fetchMethod("POST");
